import React from 'react';
import DocumentTextIcon from '@heroicons/react/outline/DocumentTextIcon.js';
import { BlockType } from '../../types/index.js';
import { PostBlock as Component } from './Block.js';
export const RegisteredPostBlock = (intl) => {
    const { $t } = intl;
    return {
        recommendedName: 'Post',
        Component,
        config: {
            type: BlockType.Block,
            displayName: $t({
                id: 'Blocks.Post.DisplayName',
                defaultMessage: 'Post',
            }),
            usable: false,
            defaultProps: {
                id: '{{ postId }}',
            },
            Icon: React.createElement(DocumentTextIcon, null),
        },
    };
};
//# sourceMappingURL=registered.js.map